<script setup>
// Imports
import { usePageLoading } from 'src/composables/usePageLoading'

// Props
const props = defineProps({
  label: { type: String, required: true },
  caption: { type: String, default: '' },
  value: { type: [String, Number], default: null },
  icon: { type: String, default: 'format_list_bulleted' },
  color: { type: String, default: 'primary' },
  hint: { type: String, default: '' },
  loading: { type: Boolean, default: false },
  compact: { type: Boolean, default: false },
})

// Constants
const usesPageLoading = usePageLoading(() => props.loading)
</script>

<template>
  <q-card flat bordered class="omni-summary-card" :class="{ 'omni-summary-card--compact': compact }">
    <q-card-section class="row items-center no-wrap full-height">
      <q-icon v-if="!compact" :name="icon" :color="color" size="32px" class="q-mr-md" />
      <div class="col min-width-0">
        <q-skeleton v-if="loading && !usesPageLoading" type="text" :width="compact ? '36px' : '64px'" :height="compact ? '21px' : '36px'" />
        <div v-else class="omni-summary-value">{{ typeof value === 'number' ? $n(value) : (value ?? '-') }}</div>
        <div class="text-body1">{{ label }}</div>
        <div v-if="caption" class="text-body2 text-grey-7">{{ caption }}</div>
      </div>
      <q-btn v-if="hint" flat round dense icon="sym_o_info" color="primary" size="sm" class="absolute-top-right q-ma-xs" :aria-label="hint">
        <q-tooltip max-width="320px" class="text-body1">{{ hint }}</q-tooltip>
      </q-btn>
    </q-card-section>
  </q-card>
</template>
